export default __webpack_public_path__ + "static/media/CNo.69-4.4ec9a5a9.jpg";